"use strict";
var rounds;
(function (rounds) {
    rounds[rounds["SEMI_FINAL"] = -1] = "SEMI_FINAL";
    rounds[rounds["GRAND_FINAL"] = 0] = "GRAND_FINAL";
})(rounds || (rounds = {}));
var gameState;
(function (gameState) {
    gameState[gameState["NOT_STARTED"] = 0] = "NOT_STARTED";
    gameState[gameState["FIRST_QUARTER"] = 1] = "FIRST_QUARTER";
    gameState[gameState["SECOND_QUATER"] = 2] = "SECOND_QUATER";
    gameState[gameState["THIRD_QUATER"] = 3] = "THIRD_QUATER";
    gameState[gameState["FINISHED"] = 4] = "FINISHED";
})(gameState || (gameState = {}));
var Game = (function () {
    function Game(id, t1, t2, start, court, isBye, round, t1GAScore, t1GSScore, t2GAScore, t2GSScore, state, t1AssPlayers, t2AssPlayers) {
        this.id = id;
        this.t1 = t1;
        this.t2 = t2;
        this.start = start;
        this.court = court;
        this.isBye = isBye;
        this.round = round;
        this.t1GAScore = t1GAScore;
        this.t1GSScore = t1GSScore;
        this.t2GAScore = t2GAScore;
        this.t2GSScore = t2GSScore;
        this.state = state;
        this.t1AssPlayers = t1AssPlayers;
        this.t2AssPlayers = t2AssPlayers;
        this.isFirstGame = false;
        this.date = $["format"].date(this.start, "D MMM yyyy");
        this.time = window["formatTime"](this.start);
    }
    Game.prototype.vsString = function () {
        if (this.state == gameState.FINISHED) {
            return this.t1Score() + " to " + this.t2Score();
        }
        else
            return "vs";
    };
    Game.prototype.t1Name = function () {
        if (this.isBye && !this.t1)
            return "Bye";
        else
            return this.t1.name;
    };
    Game.prototype.t2Name = function () {
        if (this.isBye && !this.t2)
            return "Bye";
        else
            return this.t2.name;
    };
    Game.prototype.t1Score = function () {
        return (this.t1GAScore + this.t1GSScore);
    };
    Game.prototype.t2Score = function () {
        return (this.t2GAScore + this.t2GSScore);
    };
    Game.prototype.roundString = function () {
        if (this.round === rounds.SEMI_FINAL)
            return "SEMI FINALS";
        else if (this.round === rounds.GRAND_FINAL)
            return "FINAL";
        else
            return "Round " + this.round;
    };
    Game.prototype.isFinished = function () {
        return this.state === gameState.FINISHED;
    };
    Game.prototype.isNotStarted = function () {
        return this.state === gameState.NOT_STARTED;
    };
    return Game;
}());
exports.Game = Game;



/*****************
 ** WEBPACK FOOTER
 ** ./src/game.ts
 ** module id = 58
 ** module chunks = 1
 **/